<template>
	<ul class="main-menu">

		<template v-for="menux in menus">
			<li class="sub-header">{{ menux.header }}</li>
			<li class="has-sub-menu" v-for="menu in menux.menus"
			    v-on:click="openMenu(menu)"
			    v-on:mouseover="(w >= 1200) ? menu.active = true : ''"
			    v-on:mouseleave="(w >= 1200) ? menu.active = false : ''"
			    :class="(menu.active) ? 'active' : ''">
				<a :href="(menu.sub) ? 'javascript:void()' : '/#/'+menu.route" :class="(!menu.sub) ? 'docka' : ''">
					<div class="icon-w">
						<i :class="menu.icon"></i>
					</div>
					<span class="capitalize">{{ menu.title }}</span>
				</a>
				<div class="sub-menu-w" v-if="menu.sub" >
					<div class="sub-menu-header">
						{{ menu.title }}
					</div>
					<div class="sub-menu-icon">
						<i :class="menu.icon"></i>
					</div>
					<div class="sub-menu-i">
						<ul class="sub-menu capitalize">
							<li v-for="(index, sub) in menu.sub">
								<a :href="'/#/'+index.route" class="docka">{{ index.title }}</a>
							</li>
						</ul>
					</div>
				</div>
			</li>
		</template>
		<li class="pull-right">
			<div class="mt-2 p-2">
				<div id="toggles">
					<input type="checkbox" id="darkmode__" v-model="darkMode" name="darkmode__" value="1" class="ios-toggle">
					<label for="darkmode__" class="checkbox-label"></label>
				</div>
			</div>
		</li>
	</ul>
</template>

<script>

    export default {
        name: 'dock',
        data () {
            return {
                w: window.innerWidth,
	            darkMode: false,
                t: this.$root.t,
                active: false,
	            userRole: null,
                menus: [
	                {
                        header: this.$root.t.navigation.sportsbook,
                        menus:
                            [
                                {route: '', title: this.$root.t.navigation.live_fixture, icon: 'icon-fire', active: false,
                                    sub: [
                                        {route: 'fixture?onLive=1', title: this.$root.t.sportsbook.filter.playing, icon: '', active: false },
                                        {route: 'fixture?isLive=1&upcoming=24 hours', title: '24h', icon: '', active: false },
                                        {route: 'fixture?isLive=1&upcoming=48 hours', title: '48h', icon: 'os-icon os-icon-grid-circles', active: false },
                                    ]
                                },
                              {route: 'templates', title: this.$root.t.navigation.market, icon: 'icon-book-open', active: false },
                              {route: 'sports', title: this.$root.t.navigation.sport, icon: 'fa fa-eercast', active: false },
                            ]
                    },
                ]
            }
        },
	    watch: {
            'darkMode' (o,n) {
                this.$bus.$emit('darkMode', this.darkMode)
            }
	    },
	    mounted () {
			var self = this;
            this.$getItem('darkMode', function (key, value) {
                //console.log all the kay/value pairs
                self.darkMode = value;
                self.$root.darkMode = value;

            }, function (err) {

            })
	    },
        methods: {
            openMenu (menu) {
                if (menu.active == false) {
                    menu.active = true;
                } else {
                    menu.active = false;
                }
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/dock.vue